import { render, staticRenderFns } from "./ComplianceCard.vue?vue&type=template&id=bcc44fa2&scoped=true&"
import script from "./ComplianceCard.vue?vue&type=script&lang=js&"
export * from "./ComplianceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc44fa2",
  null
  
)

export default component.exports